import { render } from "./component-main-place.vue?vue&type=template&id=312936e0"
import script from "./component-main-place.vue?vue&type=script&setup=true&lang=js"
export * from "./component-main-place.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-main-place.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "312936e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('312936e0', __exports__)) {
    api.reload('312936e0', __exports__)
  }
  
  module.hot.accept("./component-main-place.vue?vue&type=template&id=312936e0", () => {
    api.rerender('312936e0', render)
  })

}


export default __exports__